import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MODAL_DATA } from 'src/app/helpers/modal.tokens';

@Component({
  selector: 'app-update-phase-modal',
  templateUrl: './update-phase-modal.component.html',
  styleUrls: ['./update-phase-modal.component.scss']
})
export class UpdatePhaseModalComponent implements OnInit {
  updatedPhaseData: any;

  constructor(
    @Inject(MODAL_DATA) public data: any,
    private dialogRef: MatDialogRef<any>,
    private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

  close(result: any) {
    this.dialogRef.close({btnValue: result, phaseData: this.updatedPhaseData});
  }

  getPhaseData(event: any) {
    this.updatedPhaseData = {
      startDate: this.datePipe.transform(new Date(event.date), 'dd.MM.yyyy'),
      projectPhaseUuid: event.phase.uuid
    };
  }

}
